module.exports = __webpack_public_path__ + "img/bar-chart-square-plus.56a88966.svg";